import dynamic from 'next/dynamic';
import { TabListProps } from './TabList.types';

export const TabList = dynamic<TabListProps>(() => import('./TabList').then(module => module.TabList));
